export enum TypePreference {
  ToolTip = 0
}